(function () {
    'use strict';

    a3_cabin_reports.directive('jumpseatSubmittedRequestsPanel', jumpseatSubmittedRequestsPanel);

    function jumpseatSubmittedRequestsPanel() {
        function link(scope) {
            scope.submittedRequestsPanelState = {
                isOpen: true
            };

            scope.toggleSubmittedRequestsPanel = toggleSubmittedRequestsPanel;

            function toggleSubmittedRequestsPanel() {
                scope.submittedRequestsPanelState.isOpen = !scope.submittedRequestsPanelState.isOpen;
            }

             scope.getStatusBorderClass = getStatusBorderClass;
            function getStatusBorderClass(statusValue) {
                if (statusValue === 2) {
                    return 'border-left-green';
                }

                if (statusValue === 3) {
                    return 'border-left-red';
                }

                return 'border-left-blue';
            }
        }
        
        return {
            restrict: 'E',
            templateUrl: 'views/JumpseatRequests/submittedRequestsPanel.tpl.html',
            scope: false,
            link: link
        };
    }
})();
